import { absoluteUrl } from "../lib/api";

const Slider = ({ label, testid, value, onChange, min, max, step, format }) => (
  <label className="block">
    <div className="flex items-center justify-between">
      <span className="label-mono">{label}</span>
      <span className="text-xs text-zinc-500">{format(value)}</span>
    </div>
    <input
      type="range"
      data-testid={testid}
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="mt-3 w-full accent-[#FF5A00]"
    />
  </label>
);

// variant "story" = 9:16 card with navy stat panel, "hero" = wide profile banner
export const CardFraming = ({
  src, focusX, focusY, zoom, onChange, keys,
  variant = "story", defaults = { x: 0.5, y: 0.25, zoom: 1 }, testidPrefix = "framing",
}) => {
  const story = variant === "story";
  const frame = story ? "w-[189px] h-[336px]" : "w-full max-w-[420px] h-[236px]";
  const photoWidth = story ? "56.5%" : "100%";
  const imgStyle = {
    objectPosition: `${focusX * 100}% ${focusY * 100}%`,
    transform: `scale(${zoom})`,
    transformOrigin: `${focusX * 100}% ${focusY * 100}%`,
  };

  return (
    <div className="border border-white/10 bg-[#0b0b0b] p-5" data-testid={`${testidPrefix}-block`}>
      <div className="flex flex-col md:flex-row gap-6">
        <div className="shrink-0">
          <p className="label-mono mb-3">{story ? "Story card preview" : "Profile hero preview"}</p>
          <div
            className={`relative overflow-hidden bg-[#051128] border border-white/10 ${frame}`}
            data-testid={`${testidPrefix}-preview`}
          >
            {src ? (
              <div className="absolute inset-0 overflow-hidden" style={{ width: story ? "100%" : photoWidth }}>
                <img src={absoluteUrl(src)} alt="" className="w-full h-full object-cover" style={imgStyle} />
              </div>
            ) : (
              <div
                className="absolute inset-y-0 left-0 flex items-center justify-center text-[10px] text-zinc-500 px-2 text-center"
                style={{ width: photoWidth }}
              >
                Add a photo to preview
              </div>
            )}
            {story && (
              <>
                <div className="absolute inset-y-0 right-0 bg-[#0A1E42]/90" style={{ width: "39.8%" }} />
                <div className="absolute inset-y-0 bg-[#FF5A00]" style={{ left: "59.6%", width: "3px" }} />
              </>
            )}
            {!story && (
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />
            )}
          </div>
        </div>

        <div className="flex-1 space-y-6 self-center">
          <Slider
            label="Move up / down"
            testid={`${testidPrefix}-y`}
            value={focusY}
            min={0}
            max={1}
            step={0.01}
            format={(v) => `${Math.round(v * 100)}%`}
            onChange={(v) => onChange({ [keys.y]: v })}
          />
          <Slider
            label="Move left / right"
            testid={`${testidPrefix}-x`}
            value={focusX}
            min={0}
            max={1}
            step={0.01}
            format={(v) => `${Math.round(v * 100)}%`}
            onChange={(v) => onChange({ [keys.x]: v })}
          />
          <Slider
            label="Zoom"
            testid={`${testidPrefix}-zoom`}
            value={zoom}
            min={1}
            max={3}
            step={0.05}
            format={(v) => `${v.toFixed(2)}×`}
            onChange={(v) => onChange({ [keys.zoom]: v })}
          />
          <button
            type="button"
            data-testid={`${testidPrefix}-reset-btn`}
            onClick={() =>
              onChange({ [keys.x]: defaults.x, [keys.y]: defaults.y, [keys.zoom]: defaults.zoom })
            }
            className="label-mono text-[#FF5A00] hover:text-white"
          >
            Reset framing
          </button>
        </div>
      </div>
    </div>
  );
};
